import React from 'react';
import { useTranslation } from 'react-i18next';
import { IcoLn, lineText } from '../ActionIcons';

// The ONE drawer header: eyebrow + tools (expand: the chevron pointing left to widen, right to reduce (R-G), optional full page, close ✕; every tool has title + aria-label EN+FR)
// then the title (+ ini badge), optional meta line, status rail, badges. `size` is 'standard' | 'expanded'; no onSize = no expand tool.
export default function DrawerHeader({ eyebrow, title, ini, titleId, titleExtra, meta, metaTestId, rail, railTestId, badges, size, onSize, onFullPage, onClose, children }) {
  const { t } = useTranslation('actions');
  const exp = size === 'expanded';
  const tool = (label, onClick, glyph, testId, cls = '') => <button type="button" className={'tool' + cls} title={label} aria-label={label} onClick={onClick} data-testid={testId}>{glyph}</button>;
  return (
    <div className="dr-head">
      <div className="dr-top">
        <span className="eyebrow">{eyebrow}</span>
        <div className="tools">
          {onSize && tool(t(exp ? 'reducePanel' : 'expandPanel'), onSize, <IcoLn name="chevron" />, 'dr-expand', exp ? ' dr-chev-r' : ' dr-chev-l')}
          {onFullPage && tool(t('openFullPage'), onFullPage, <IcoLn name="order" />)}
          {tool(t('close'), onClose, <IcoLn name="close" />, 'dr-close')}
        </div>
      </div>
      <div className="dr-title" id={titleId}>{ini != null && <span className="ini" aria-hidden="true">{typeof ini === 'string' ? lineText(ini) : ini}</span>} {title}{titleExtra}</div>
      {meta && <div className="dr-meta" data-testid={metaTestId}>{meta}</div>}
      {rail && <div className="rail" data-testid={railTestId}>{rail}</div>}
      {badges && <div className="badges">{badges}</div>}
      {children}
    </div>
  );
}
